module.exports = __webpack_public_path__ + "img/icon-dropdown-open.9683fc8a.svg";